import {} from "../actions/types";

const initialState = {
	loading: true,
	trashList: [],
	// the trash tab trashList was loaded for, since every tab shares it
	trashPageContext: null,
	// the last refresh was rate limited, so trashList may be out of date
	listStale: false,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case "GET_TRASH_REQUEST": {
			const { trashPageContext } = action.payload;
			// another tab's items aren't stale data for this one
			const switchedTabs = trashPageContext !== state.trashPageContext;
			return {
				...state,
				loading: true,
				trashPageContext,
				trashList: switchedTabs ? [] : state.trashList,
				listStale: switchedTabs ? false : state.listStale,
			};
		}

		case "GET_TRASH_SUCCESS": {
			return {
				...state,
				loading: false,
				trashList: action.payload.trashList,
				listStale: false,
			};
		}

		case "GET_TRASH_FAILURE": {
			return {
				...state,
				loading: false,
				listStale: !!action.payload?.rateLimited,
			};
		}

		case "HIDE_ITEMS_PERM_DELETE_STARTED_WITH": {
			return {
				...state,
				trashList: action.payload.trashList,
			};
		}

		default:
			return state;
	}
}
